import { GLAMMATIC_SUPPORT_EMAIL } from '../../../../constants/constants';

export const ERROR_MESSAGE_CONTENT = `Please contact ${GLAMMATIC_SUPPORT_EMAIL} for assistance.`;

export const SQUARE_PROVIDER = 'Square';
export const SQUARE_SERVICE_TYPE = 'Merchant';
